import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URLS } from 'src/shared/constants/api-request.urls';
import { map } from 'rxjs/operators';

export interface EventApiResponse {
  id: string;
  type: string;
  name: string;
  symbol: string;
  image?: string;
  imageFile?: string;
  eventData: any;
  stockId?: string;
}

@Injectable({ providedIn: 'root' })
export class EventsService {
  private http = inject(HttpClient);

  getEvents(top: number = 4): Observable<EventApiResponse[]> {
    return this.http
      .get<{ data: EventApiResponse[] }>(`${URLS.EVENTS}?top=${top}`)
      .pipe(map((response) => response.data));
  }
}
